import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationRU from './locales/ru/translation.json';
import translationEN from './locales/en/translation.json';

const resources = {
  RUS: { translation: translationRU },
  ENG: { translation: translationEN }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    // Do not hard-code initial lng; it will be set before first render
    fallbackLng: 'RUS',
    interpolation: { escapeValue: false }
  });

export default i18n; 